/** フィルター使用時に全件取得する際の上限。バックエンドの上限に合わせること。 */
export const FILTER_FETCH_LIMIT = 10000;
